import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const PrivacyPolicy = () => {
  return (
    <div className="privacypolicycontent">
      <Navbar />
      <div className="privacypolicy">
        <h1>Privacy Policy</h1>
        <br />

        <p>
          This website is published and maintained by Tron Healthcare Private
          Limited (“TronHC”). The Privacy Policy is applicable to the websites
          of Tron Healthcare Private Limited including http://www.Tron.health/
          which also comprises of the Mobile Site, Smartphone App Platforms such
          as IOS, Android, Windows (all together referred to as “Site”). This
          privacy policy does not apply to the websites of our business
          partners, service providers, and corporate affiliates or to any other
          third parties, even if their websites are linked to the site. We
          recommend you review the respective privacy statements of the other
          parties with whom you interact.
        </p>
        <br />
        <p>
          By browsing, visiting, accessing and/or using the services on this
          Site (or searching for any of the pages on this Site), the Site
          Visitor (“You”) explicitly consents and agrees to our Privacy Policy
          laid out herein. You also agree that the information furnished by you
          is lawful, true and correct and does not violate or infringe any laws.
          In case of any violations, infringement, furnishing of wrongful or
          unauthorized information, TronHC shall not be liable for the same.
        </p>
        <br />
        <p>
          We encourage you to review our Privacy Policy and familiarize yourself
          with it. Please note that we review our Privacy Policy from time to
          time, and we may make periodic changes to the policy in connection
          with that review. Therefore, you may wish to bookmark this page and/or
          periodically review this page to make sure you have the latest version
          of the Privacy Policy.
        </p>
        <br />
        <br />
        <h3>What information does TronHC collect, collate and/ or use?</h3>
        <br />
        <ul>
          <li>
            Personally identifiable information like name(s) and contact details
            which may include e-mail address or contact number(s), password,
            etc.
          </li>
          <li>
            Transactional information like financial information such as bank
            account or credit card or debit card or other payment instrument
            details, etc.
          </li>
          <li>
            Location information including the location of the patient for
            suggesting a place to provide services by our registered service
            provider, etc.
          </li>
          <li>
            Other information may be requested or gathered while you visit,
            access or use the Site.
          </li>
          <li>
            Besides the above, when you browse the Website, TronHC may collect
            information regarding the domain and host from which you access the
            Internet, the Internet Protocol address of the computer or Internet
            Service Provider you are using, and anonymous site statistical data,
            the information furnished while navigating the Site, the systems and
            programs used and the time spent on our Site along with any other
            relevant information.
          </li>
        </ul>
        <br />
        <p>
          The Website uses cookie and tracking technology depending on the
          features offered. Aggregate cookie and tracking information may be
          shared with third parties to provide you with a better service and
          experience.{" "}
        </p>
        <br />
        <p>
          We may also collect and furnish such other information as is required
          in compliance with various laws, court orders, as requested by other
          government or law enforcement authorities, or in the good faith belief
          that disclosure is otherwise necessary or advisable including, without
          limitation, to protect the rights or properties of TronHC or any or
          all of its affiliates, associates, employees, directors or officers or
          when we have reason to believe that disclosing the information is
          necessary to identify, contact or bring legal action against someone
          who may be causing interference to our operational rights, interests,
          whether intentionally or otherwise, or when anyone else could be
          harmed by such activities.
        </p>

        <br />

        <h3>What is this information used for?</h3>
        <br />
        <ul>
          <li>
            To provide available services on the Site such as appointment
            booking, etc. and payment transactions for the services available on
            the Site
          </li>
          <li>
            To personalise your experience and give you better service: (your
            information helps us to better respond to your individual needs)
          </li>
          <li>
            To improve the user-friendliness of the Site; (we continually strive
            to improve the Site offerings based on the information we receive
            from you)
          </li>
          <li>
            To improve customer service (your information helps us to more
            effectively respond to your customer service requests and support
            needs)
          </li>
          <li>Website traffic analysis</li>
          <li>
            To administer a contest, promotion, survey or other Site feature
          </li>
          <li>
            To send emails, SMS and other communications for providing services,
            responding to inquiries, and/ or other requests or questions
          </li>
          <li>
            To respond to queries of the authorities in regard to your accessing
            of the Site and services availed by you
          </li>
        </ul>
        <br />
        <br />

        <h3>Automatic logging of session data </h3>
        <br />
        <p>
          Of course, you are solely responsible for maintaining the secrecy of
          your passwords, and your membership account information. Please be
          very careful, responsible, and alert with this information, especially
          whenever you are online.
        </p>

        <br />
        <br />

        <h3>Cookies and how do we use them? </h3>
        <br />
        <p>
          Cookies are small files that a Site or its service provider transfers
          to your computer hard drive through your web browser (if you allow) to
          enable the Sites or service provider systems to recognise your browser
          and capture and remember certain information. Yes, we use cookies to
          understand and save your preferences for future visits and keep track
          of advertisements. This helps us to serve you better and more
          efficiently and to personalise your experience on our website.{" "}
        </p>
        <br />
        <p>
          Similarly, a cookie may be placed by our third–party advertising
          companies or advertisement providers. These companies may use
          aggregated statistics about your visits to this and other websites in
          order to provide you advertisements about our health–related plans and
          services, your preferences in or any plans and services of potential
          interest to you. The third–party advertising companies or
          advertisement providers may also employ technology that is used to
          measure the effectiveness of our ads, your preference and other
          relevant statistical data to serve you better. Any such information
          may be anonymous about your visits to this and other sites and does
          not link online actions to an identifiable person. <br /> <br />
          Generally, the web browsers are programmed to automatically accept
          cookies but if you desire to opt out of receiving the cookies you can
          do so by changing the options on your web browser or using certain
          software programs, you can control how and whether the cookies will be
          accepted by your browser. TronHC does respect your right to block any
          unwanted internet activity, especially that of unscrupulous websites,
          though blocking cookies from the usage of TronHC Site may disable
          certain features on the Site, and may make it impossible to purchase
          or use certain services available on the Site. Please note that it is
          possible to block cookie activity from certain websites while
          permitting cookies from websites you trust, like TronHC website.
          <br /> <br />
          We do not sell, trade, or otherwise transfer to outside parties your
          personally identifiable information. However, we do transmit your
          information to trusted third parties who assist us in operating our
          website, conducting our business, or servicing you, so long as those
          parties agree to keep this information confidential. We may also
          release your information when we believe release is appropriate to
          comply with the law, enforce our site policies, or protect our or
          others rights, property, or safety. However, other non-personally
          identifiable visitor information may be provided to other parties for
          marketing, advertising, or other uses.
        </p>

        <br />

        <br />

        <h3>Third-party links </h3>
        <br />
        <p>
          TronHC Site contains links to other websites. Please note that when
          you click on one of these links, you are entering another website for
          which TronHC has no responsibility and these third-party sites have
          separate and independent privacy policies which you will have to
          acquaint yourselves with. We encourage you to read the privacy
          statements of all such sites as their policies may be materially
          different from our Privacy Policy. We, therefore, have no
          responsibility or liability for the content and activities of these
          linked sites. Nonetheless, we seek to protect the integrity of our
          site and welcome any feedback about these sites.
        </p>
        <br />
        <br />
        <h3>Security </h3>
        <br />
        <p>
          Transactions on the website are protected by SSL (Secure Sockets
          Layer) and Secure Data Encryption using a 1024-bit process. Any
          information you enter when transacting with the website is sent in a
          Secure Socket Layer (SSL) session and is encrypted to protect you
          against unintentional disclosure to third parties. This is an
          assurance that it follows the best security practices adopted by major
          online vendors where all payments are processed in real-time for your
          security and immediate peace of mind. Credit card and debit card
          information is not stored by us and is not taken by us. This
          information is taken directly by the payment gateway provided who is
          authorised and is compliant with the regulations and requirements of
          various banks and institutions and payment franchisees that it is
          associated with. To report security vulnerabilities affecting any of
          our products, send an email to support@tron.health
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
